import React from "react";
import "../../Styles/pages/product.scss";
import "../../Styles/pages/products.scss";
import { FullWidthCardTemplate } from "../Products/ProductSummaryInsights";

const formatCell = (value) => (value != null && value !== "" ? value : "--");

const EnrichmentDetailCards = ({ t, summary, requestId, formatDateTime }) => {
    const hasSummaryDetails = summary?.completedOn != null || summary?.pendingItemCount != null;
    const completedOnFormatted = summary?.completedOn ? formatDateTime(summary.completedOn) : null;

    const mainCardEnrichment = [
        {
            page: "enrichment-detail",
            t,
            enrichmentDetState: { summary, requestId },
            completedOnFormatted,
            entryCountDisplay: formatCell(summary?.entryCount),
            pendingCountDisplay: formatCell(summary?.pendingItemCount),
            unmatchedCountDisplay: formatCell(summary?.unmatchedCount),
            hasSummaryDetails,
        },
    ];

    return (
        <div className="grid nested-grid enrichment-detail-layout">
            <section className="col-12 enrichment-detail-main">
                <div className="grid plan-detail-header-grid">
                    <FullWidthCardTemplate summary={mainCardEnrichment} />
                </div>
            </section>
        </div>
    );
};

export default EnrichmentDetailCards;
